// Promise is required for correct lazy loading of other polyfills
// so we need to always include it before other polyfills
import 'polyfills/promise/polyfill';

import polyfills from 'polyfills';
import { REACT_APP_API_URL } from 'helpers/conf';

async function showReactDOM() {
  try {
    await Promise.all(polyfills);
  } catch (error) {
    console.error('Error loading polyfills:', error);
  } finally {
    console.log('******** APP TS', REACT_APP_API_URL);
    await window.PaymentsAPI?.config({
      language: 'en',
      serverUrl: REACT_APP_API_URL,
      cdnList: ['https://cdn.softswiss.net', 'https://cdn2.softswiss.net'],
    });

    require('renderer');
  }
}

showReactDOM();
